import React, { ReactNode } from 'react';
import styled from 'styled-components';

import { Box } from 'components/Box';
import { Divider } from 'components/Divider';
import { GridItem } from 'components/Grid';
import { Hide } from 'components/Hide';
import { breakpoints } from 'theme';

const Sidebar = styled.aside`
  width: 100%;
  margin: 0 auto;
  @media (min-width: ${breakpoints[2]}) {
    width: 300px;
    margin: 0;
  }
`;

function SidebarDivider() {
  return (
    <Hide lg xl>
      <Box my={['48px', '64px', null, null]} mx="auto">
        <Divider />
      </Box>
    </Hide>
  );
}

type Props = {
  sidebar: ReactNode;
  position: string;
};

export function ContentPageGridSidebar({ sidebar, position }: Props) {
  return (
    <GridItem
      columnStart={[1, 1, 8, 9]}
      columnEnd={[13, 13, 13, 13]}
      justifySelf="end"
      order={2}
    >
      {position === 'lower' && <SidebarDivider />}
      <Sidebar>{sidebar}</Sidebar>
      {position === 'upper' && <SidebarDivider />}
    </GridItem>
  );
}
